import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const getErrUploadApi = async () => {
  try {
    const response = await axios.get(BASE_URL + `v1/${STAGE}/error-upload`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
